import styled from 'styled-components';

export const StyledHeroContainer = styled.div`
	width: 65%;
	margin: 25vh auto;
	height: 50vh;

	@media (min-width: 1440px) {
		width: 50%;
	}
`;
